import React from 'react';

import { SourceComponent } from '~/types';
import ProductGroupsComboboxView from '~/app/views/ProductGroups/ProductGroupsComboboxView';
import Combobox from './primitives/Combobox';
import { t } from '../l10n/l10n';
import { ProductGroup } from '../../../../types/internal-api';
import { useProductGroups } from '../../hooks/masterdata/useProductGroups';

export interface ProductGroupComboboxProps {
    onCreated?: () => void;
    useCache?: boolean;

    showCreateOnTheFly?: boolean;
    [prop: string]: any;
}

export default function ProductGroupCombobox({
    onCreated,
    useCache,
    showCreateOnTheFly = true,
    ...props
}: ProductGroupComboboxProps) {
    const { data: productGroups } = useProductGroups({ options: { useCache } });

    return (
        <Combobox
            {...props}
            aria-label={props['aria-label'] ?? t`FORM_GOODSGROUPS_HEADLINE`}
            data={productGroups.map(productGroup => ({
                data: productGroup,
                text: `${productGroup.id} - ${productGroup.name}`,
                summary: productGroup.name,
                value: productGroup.id,
            }))}
            modal={({ hide, onChange }) => {
                const productGroupsModalProps = {
                    showCreateOnTheFly,
                    onCreated: (productGroup: ProductGroup) => {
                        onCreated?.();
                        onChange(productGroup.id, productGroup, true);
                        hide();
                    },
                    onSelected: (productGroup: ProductGroup) => {
                        onChange(productGroup.id, productGroup, true);
                        hide();
                    },
                    sourceComponent: SourceComponent.ComboBox,
                };

                return <ProductGroupsComboboxView {...productGroupsModalProps} />;
            }}
            modalSize="sm"
        />
    );
}
